import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = window.location.hash.match(/session_id=([^&]+)/);
    const sid = m ? m[1] : null;
    window.history.replaceState(null, "", window.location.pathname);
    if (!sid) return navigate("/login", { replace: true });
    api
      .post("/auth/session", { session_id: sid })
      .then(({ data }) => {
        setUser(data);
        navigate("/dashboard", { replace: true });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [navigate, setUser]);

  return null;
}
